import type { CompanyResponse } from '../identity/types';
import { createJsonClient } from '../../shared/httpClient';
import type { CompaniesGateway, CreateCompanyInput, UpdateCompanyInput } from './CompaniesGateway';

/** Relative base URL, same as HttpIdentityGateway — /api/companies lives on EPN.Identity.Api itself. */
export class HttpCompaniesGateway implements CompaniesGateway {
  private readonly request = createJsonClient('');

  listMine(signal?: AbortSignal): Promise<CompanyResponse[]> {
    return this.request('/api/companies', undefined, signal);
  }

  getById(companyId: string, signal?: AbortSignal): Promise<CompanyResponse> {
    return this.request(`/api/companies/${companyId}`, undefined, signal);
  }

  create(input: CreateCompanyInput): Promise<CompanyResponse> {
    return this.request('/api/companies', { method: 'POST', body: JSON.stringify(input) });
  }

  update(companyId: string, input: UpdateCompanyInput): Promise<CompanyResponse> {
    return this.request(`/api/companies/${companyId}`, { method: 'PUT', body: JSON.stringify(input) });
  }
}
